export default __webpack_public_path__ + "static/SiemensSans-Black-490fa28423f600e8e9c989c5ca639b2e.ttf";